// import { SVG } from "@/assets/svg";
// import APIConstants from "@/constants/api.constants";
// import { Suspense } from "react";
// import DefaultLoader from "@/component/loader";
// import { IGetMineral } from "@/interfaces/add-mineral-specimen.interface";
// import PopupModal from "@/component/modals/PopupModal";
// import SocialShare from "@/component/social-link";
// import { Card } from "antd";
// import React, { useState } from "react";
// import { Colors } from "@/styles/Colors";
// import styles from "./card.module.css";
// import { IMAGES } from "@/assets/images";
// import Link from "next/link";
// import { errorToast, showDeleteWarningModal, successToast } from "../toasts";
// import CustomImage from "../customImage";
// import {
//   postComment,
//   postLike,
//   postReport,
//   postShare,
// } from "@/utils/apis/minerals/like-share-comment.api";
// import { useAppContext } from "@/context";
// import { updatePinnedMineral } from "@/utils/apis/minerals/edit-minerals.api";
// import { useRouter } from "next/router";

// type Props = {
//   onDelete?: (id: string) => void;
//   href: string;
//   customImageStyles?: React.CSSProperties;
//   item: IGetMineral;
//   isSelected?: boolean;
//   mineralBadge?: boolean;
//   featuredMinerals?: boolean;
//   mineralBadgeName?: string;
//   onSelect?: () => void;
//   type?: string;
//   isPinned?: boolean;
// };

// function MineralCard({
//   item,
//   onDelete,
//   href,
//   customImageStyles,
//   mineralBadge,
//   mineralBadgeName,
//   featuredMinerals,
//   isSelected,
//   onSelect,
//   type,
//   isPinned,
// }: Props) {
//   const router = useRouter();
//   const { user, handleLoginPopupOpen }: any = useAppContext();
//   const mineralId = item?._id as string;
//   const slug = item?.slug as string;
//   const [liked, setLiked] = useState(item?.likedBy?.includes(user?._id));
//   const [likeCount, setLikeCount] = useState(item?.like);
//   const [commentLoading, setCommentLoading] = useState(false);
//   const [isUploadPopupVisible, setUploadPopupVisible] = useState(false);
//   const [pinned, setPinned] = useState(isPinned);

//   const image = item?.coverIndex?.path
//     ? `${APIConstants.image_url}${item.coverIndex?.path}`
//     : item.images?.[0]?.path
//     ? `${APIConstants.image_url}${item.images?.[0]?.path}`
//     : IMAGES.PlaceholderImage;

//   const handlePinToggle = async () => {
//     const newPinnedState = !pinned;
//     setPinned(newPinnedState);
//     const body = {
//       id: item?._id,
//       isPinned: newPinnedState,
//     };
//     try {
//       const response = await updatePinnedMineral(body);

//       if (!response.data.success) {
//         errorToast(response?.data?.message);
//         setPinned(!newPinnedState);
//       }
//     } catch (error) {
//       console.error("Error updating pinned state:", error);
//       errorToast("Failed to update pinned state. Please try again.");
//       setPinned(!newPinnedState);
//     }
//   };

//   const renderStars = (rating: number) => {
//     const fullStars = Math.floor(rating);
//     const halfStar = rating % 1 !== 0;
//     const totalStars = 1;

//     if (rating === 0 || !rating) {
//       return (
//         <div style={{ display: "flex", alignItems: "center" }}>
//           {Array.from({ length: totalStars }).map((_, index) => (
//             <SVG.EmptyStar key={`empty-${index}`} width="20px" fill="#E0E0E0" />
//           ))}
//           <span
//             style={{ marginLeft: "8px", fontSize: "14px", color: "#5E5E5E" }}
//           >
//             {rating || 0}
//           </span>
//         </div>
//       );
//     }

//     return (
//       <div style={{ display: "flex", alignItems: "center" }}>
//         {Array.from({ length: fullStars }).map((_, index) => (
//           <SVG.Star key={`full-${index}`} width="20px" fill="#FFD700" />
//         ))}
//         {halfStar && rating && <SVG.HalfStar width="20px" fill="#FFD700" />}
//         <span style={{ marginLeft: "8px", fontSize: "14px", color: "#5E5E5E" }}>
//           {rating}
//         </span>
//       </div>
//     );
//   };

//   const handleLikeCommentShare = async (key: string, comment?: string) => {
//     if (key === "like") {
//       setLiked((prev) => {
//         setLikeCount((count: any) => (prev ? count - 1 : count + 1));
//         return !prev;
//       });
//     }

//     if (key === "comment") {
//       if (!user) {
//         handleLoginPopupOpen();
//         return;
//       }

//       if (type === "explore") {
//         router.push(`/explore-detail?id=${mineralId}#comments`);
//       } else {
//         router.push(`/my-collection/${mineralId}#comments`);
//       }
//     }

//     let handlerFunction;
//     if (key === "like") {
//       handlerFunction = postLike;
//     } else {
//       handlerFunction = postShare;
//     }

//     try {
//       const response = await handlerFunction(mineralId);
//       console.log("<postLikeShareComment>response", response);
//     } catch (error: any) {
//       console.log("<postLikeShareComment>error", error);
//       errorToast(error.response?.data?.message || "An error occurred");
//     }
//     setCommentLoading(false);
//   };

//   const handleUploadPopupOpen = () => {
//     setUploadPopupVisible(true);
//   };

//   const handleUploadPopupClose = () => {
//     setUploadPopupVisible(false);
//   };

//   const handleShare = async () => {
//     handleLikeCommentShare("share");
//   };

//   const handleCardClick = (e: React.MouseEvent) => {
//     // If click originated from like/comment/share area, don't navigate
//     if ((e.target as HTMLElement).closest(`.${styles.countMsg}`)) {
//       e.preventDefault();
//       e.stopPropagation();
//       return;
//     }
//   };

//   const handleLikeClick = (e: React.MouseEvent) => {
//     e.preventDefault();
//     e.stopPropagation();

//     if (!user) {
//       handleLoginPopupOpen();
//       return;
//     }
//     handleLikeCommentShare("like");
//   };

//   const handleCommentClick = (e: React.MouseEvent) => {
//     e.preventDefault();
//     e.stopPropagation();

//     if (!user) {
//       handleLoginPopupOpen();
//       return;
//     }
//     handleLikeCommentShare("comment");
//   };

//   const handleShareClick = (e: React.MouseEvent) => {
//     e.preventDefault();
//     e.stopPropagation();
//     handleUploadPopupOpen();
//   };

//   return (
//     <Suspense fallback={<DefaultLoader />}>
//       <Link href={href} className={styles.cardLink}>
//         <Card
//           className={`${styles.latestCollections}`}
//           onClick={handleCardClick}
//         >
//           {!!onDelete && (
//             <div className={`${styles.edit}`}>
//               <abbr
//                 style={{
//                   cursor: "pointer",
//                   zIndex: 999,
//                 }}
//                 title={pinned ? "Unpin mineral" : "Pin mineral"}
//               >
//                 {pinned ? <SVG.Pin width="32px" fill={Colors.primary} /> : null}
//               </abbr>
//               <abbr
//                 style={{
//                   cursor: "pointer",
//                 }}
//                 title="Delete mineral"
//                 onClick={(e) => {
//                   e.preventDefault();
//                   e.stopPropagation();
//                   showDeleteWarningModal(
//                     "Are you sure to delete this mineral ?",
//                     () => onDelete?.(item?._id)
//                   );
//                 }}
//               >
//                 <SVG.Delets width="32px" />
//               </abbr>
//               <Link
//                 href={`/edit?id=${item._id}`}
//                 onClick={(e) => e.stopPropagation()}
//               >
//                 <abbr
//                   style={{
//                     cursor: "pointer",
//                   }}
//                   title="Edit mineral"
//                 >
//                   <SVG.Add width="32px" />
//                 </abbr>
//               </Link>
//             </div>
//           )}

//           {type === "my-profile" ? (
//             <div className={`${styles.edit}`}>
//               <abbr
//                 style={{
//                   cursor: "pointer",
//                   zIndex: 999,
//                 }}
//                 title={pinned ? "Unpin mineral" : "Pin mineral"}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   e.stopPropagation();
//                   handlePinToggle();
//                 }}
//               >
//                 {pinned ? (
//                   <SVG.Pin width="32px" fill={Colors.primary} />
//                 ) : (
//                   <SVG.PinOutline width="32px" />
//                 )}
//               </abbr>
//             </div>
//           ) : null}

//           <div
//             className={styles.cardClickableContent}
//             style={{ paddingBottom: "12px" }}
//           >
//             <CustomImage
//               src={image}
//               alt={item?.specimentTitle}
//               className={styles.cardImage}
//               width={0}
//               height={0}
//               sizes="100vw"
//               style={{
//                 width: "100%",
//                 height: "auto",
//                 aspectRatio: 1,
//                 objectFit: "cover",
//                 ...customImageStyles,
//               }}
//             />
//             <p className={`${styles.rattingData}`}>{item.specimentTitle}</p>
//             <div>{renderStars(item?.rating)}</div>

//             <div
//               style={{
//                 display: " flex",
//                 margin: "10px 0px",
//                 color: "#5E5E5E",
//                 fontSize: "14px",
//                 fontWeight: "500",
//               }}
//             >
//               <div style={{ width: "10%" }}>
//                 <SVG.Location
//                   style={{
//                     width: "20px",
//                   }}
//                 />
//               </div>
//               <div className={`${styles.countLocation}`}>
//                 {[
//                   item.pocket,
//                   item.minName,
//                   item.miningdistrict,
//                   item.city,
//                   item.region,
//                   item.state,
//                   item.country,
//                 ].filter(Boolean).length === 0 ? (
//                   <span>(Location not provided)</span>
//                 ) : (
//                   [
//                     item.pocket,
//                     item.minName,
//                     item.miningdistrict,
//                     item.city,
//                     item.region,
//                     item.state,
//                     item.country,
//                   ]
//                     .filter((el) => el)
//                     .join(", ")
//                 )}
//               </div>
//             </div>

//             <div
//               style={{
//                 display: " flex",
//                 margin: "10px 0px",
//                 color: "#5E5E5E",
//                 fontSize: "14px",
//                 fontWeight: "500",
//               }}
//             >
//               <div style={{ width: "10%" }}>
//                 <SVG.Diamonds
//                   style={{
//                     width: "20px",
//                   }}
//                 />
//               </div>
//               <div className={`${styles.countLocation}`}>
//                 <div>
//                   <span> Mineral:</span> <span>{item.minerals.join(", ")}</span>
//                 </div>
//               </div>
//             </div>

//             {item?.isDealerNamePublic && item?.dealerName ? (
//               <div
//                 style={{
//                   display: " flex",
//                   margin: "10px 0px",
//                   color: "#5E5E5E",
//                   fontSize: "14px",
//                   fontWeight: "500",
//                 }}
//               >
//                 <div style={{ width: "10%" }}>
//                   <SVG.Diamonds
//                     style={{
//                       width: "20px",
//                     }}
//                   />
//                 </div>
//                 <div className={`${styles.countLocation}`}>
//                   <div>
//                     <span> Dealer:</span> <span>{item.dealerName}</span>
//                   </div>
//                 </div>
//               </div>
//             ) : (
//               <div
//                 style={{
//                   display: " flex",
//                   margin: "10px 0px",
//                   color: "#5E5E5E",
//                   fontSize: "14px",
//                   fontWeight: "500",
//                 }}
//               >
//                 <div style={{ width: "10%" }}>
//                   <SVG.Diamonds
//                     style={{
//                       width: "20px",
//                     }}
//                   />
//                 </div>
//                 <div className={`${styles.countLocation}`}>
//                   <div>
//                     <span> Dealer:</span> <span>{"N/A"}</span>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>

//           <div className={`${styles.countMsg}`}>
//             <button className="heart" onClick={handleLikeClick}>
//               <SVG.Heart fill={liked ? Colors.primary : "transparent"} />{" "}
//               {likeCount || 0}
//             </button>
//             <button className="heart" onClick={handleCommentClick}>
//               <SVG.Message />
//               {item.comment?.length || 0}
//             </button>
//             <button className="heart" onClick={handleShareClick}>
//               <SVG.Send />
//               {item.share || 0}
//             </button>
//           </div>

//           {mineralBadge ? (
//             <div className={`${styles.ribbonwrapper}`}>
//               <p className={`${styles.ribbon}`}>{mineralBadgeName}</p>
//             </div>
//           ) : featuredMinerals ? (
//             <div className={`${styles.ribbonwrapper}`}>
//               <p className={`${styles.ribbon}`}>Featured</p>
//             </div>
//           ) : null}
//         </Card>
//       </Link>

//       <PopupModal
//         className={`${styles.popup}`}
//         visible={isUploadPopupVisible}
//         onClose={handleUploadPopupClose}
//         title=""
//         content={
//           <SocialShare
//             customShareUrl={`https://collectmineralclub.com/explore-detail?id=${item?.slug}`}
//             handleShare={handleShare}
//           />
//         }
//       />
//     </Suspense>
//   );
// }

// export default MineralCard;
import { SVG } from "@/assets/svg";
import APIConstants from "@/constants/api.constants";
import { Suspense } from "react";
import DefaultLoader from "@/component/loader";
import { IGetMineral } from "@/interfaces/add-mineral-specimen.interface";
import PopupModal from "@/component/modals/PopupModal";
import SocialShare from "@/component/social-link";
import { Card } from "antd";
import React, { useState } from "react";
import { Colors } from "@/styles/Colors";
import styles from "./card.module.css";
import { IMAGES } from "@/assets/images";
import Link from "next/link";
import { errorToast, showDeleteWarningModal, successToast } from "../toasts";
import CustomImage from "../customImage";
import {
  postComment,
  postLike,
  postReport,
  postShare,
} from "@/utils/apis/minerals/like-share-comment.api";
import { useAppContext } from "@/context";
import { updatePinnedMineral } from "@/utils/apis/minerals/edit-minerals.api";
import { useRouter } from "next/router";

type Props = {
  onDelete?: (id: string) => void;
  href: string;
  customImageStyles?: React.CSSProperties;
  item: IGetMineral;
  isSelected?: boolean;
  mineralBadge?: boolean;
  featuredMinerals?: boolean;
  mineralBadgeName?: string;
  onSelect?: () => void;
  type?: string;
  isPinned?: boolean;
};

function MineralCard({
  item,
  onDelete,
  href,
  customImageStyles,
  mineralBadge,
  mineralBadgeName,
  featuredMinerals,
  isSelected,
  onSelect,
  type,
  isPinned,
}: Props) {
  const router = useRouter();
  const { user, handleLoginPopupOpen }: any = useAppContext();
  const mineralId = item?._id as string;
  const slug = item?.slug as string;
  const likedBy = item?.likedBy || [];

  const [liked, setLiked] = useState<boolean>(
    !!user && likedBy.includes(user?._id)
  );

  const [likeCount, setLikeCount] = useState<number>(likedBy.length);

  const [commentLoading, setCommentLoading] = useState(false);
  const [isUploadPopupVisible, setUploadPopupVisible] = useState(false);
  const [pinned, setPinned] = useState(isPinned);

  const image = item?.coverIndex?.path
    ? `${APIConstants.image_url}${item.coverIndex?.path}`
    : item.images?.[0]?.path
    ? `${APIConstants.image_url}${item.images?.[0]?.path}`
    : IMAGES.PlaceholderImage;

  const handlePinToggle = async () => {
    const newPinnedState = !pinned;
    setPinned(newPinnedState);
    const body = {
      id: item?._id,
      isPinned: newPinnedState,
    };
    try {
      const response = await updatePinnedMineral(body);

      if (!response.data.success) {
        errorToast(response?.data?.message);
        setPinned(!newPinnedState);
      }
    } catch (error) {
      console.error("Error updating pinned state:", error);
      errorToast("Failed to update pinned state. Please try again.");
      setPinned(!newPinnedState);
    }
  };

  const renderStars = (rating: number) => {
    const fullStars = Math.floor(rating);
    const halfStar = rating % 1 !== 0;
    const totalStars = 1;

    if (rating === 0 || !rating) {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          {Array.from({ length: totalStars }).map((_, index) => (
            <SVG.EmptyStar key={`empty-${index}`} width="20px" fill="#E0E0E0" />
          ))}
          <span
            style={{ marginLeft: "8px", fontSize: "14px", color: "#5E5E5E" }}
          >
            {rating || 0}
          </span>
        </div>
      );
    }

    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        {Array.from({ length: fullStars }).map((_, index) => (
          <SVG.Star key={`full-${index}`} width="20px" fill="#FFD700" />
        ))}
        {halfStar && rating && <SVG.HalfStar width="20px" fill="#FFD700" />}
        <span style={{ marginLeft: "8px", fontSize: "14px", color: "#5E5E5E" }}>
          {rating}
        </span>
      </div>
    );
  };

  const handleLikeCommentShare = async (key: string, comment?: string) => {
    if (key === "like") {
      setLiked((prevLiked) => {
        setLikeCount((prevCount) =>
          prevLiked ? Math.max(prevCount - 1, 0) : prevCount + 1
        );
        return !prevLiked;
      });
    }

    if (key === "comment") {
      if (!user) {
        handleLoginPopupOpen();
        return;
      }

      if (type === "explore") {
        router.push(
          `/minerals/${encodeURIComponent(item?.slug || mineralId)}#comments`
        );
      } else {
        router.push(`/my-collection/${mineralId}#comments`);
      }
    }

    let handlerFunction;
    if (key === "like") {
      handlerFunction = postLike;
    } else {
      handlerFunction = postShare;
    }

    try {
      const response = await handlerFunction(mineralId);
      console.log("<postLikeShareComment>response", response);
    } catch (error: any) {
      console.log("<postLikeShareComment>error", error);
      errorToast(error.response?.data?.message || "An error occurred");
    }
    setCommentLoading(false);
  };

  const handleUploadPopupOpen = () => {
    setUploadPopupVisible(true);
  };

  const handleUploadPopupClose = () => {
    setUploadPopupVisible(false);
  };

  const handleShare = async () => {
    handleLikeCommentShare("share");
  };

  const handleCardClick = (e: React.MouseEvent) => {
    // If click originated from like/comment/share area, don't navigate
    if ((e.target as HTMLElement).closest(`.${styles.countMsg}`)) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
  };

  const handleLikeClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (!user) {
      handleLoginPopupOpen();
      return;
    }
    handleLikeCommentShare("like");
  };

  const handleCommentClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (!user) {
      handleLoginPopupOpen();
      return;
    }
    handleLikeCommentShare("comment");
  };

  const handleShareClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    handleUploadPopupOpen();
  };

  return (
    <Suspense fallback={<DefaultLoader />}>
      <Link href={href} className={styles.cardLink}>
        <Card
          className={`${styles.latestCollections}`}
          onClick={handleCardClick}
        >
          {!!onDelete && (
            <div className={`${styles.edit}`}>
              <abbr
                style={{
                  cursor: "pointer",
                  zIndex: 999,
                }}
                title={pinned ? "Unpin mineral" : "Pin mineral"}
              >
                {pinned ? <SVG.Pin width="32px" fill={Colors.primary} /> : null}
              </abbr>
              <abbr
                style={{
                  cursor: "pointer",
                }}
                title="Delete mineral"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  showDeleteWarningModal(
                    "Are you sure to delete this mineral ?",
                    () => onDelete?.(item?._id)
                  );
                }}
              >
                <SVG.Delets width="32px" />
              </abbr>
              <Link
                href={`/edit?id=${item._id}`}
                onClick={(e) => e.stopPropagation()}
              >
                <abbr
                  style={{
                    cursor: "pointer",
                  }}
                  title="Edit mineral"
                >
                  <SVG.Add width="32px" />
                </abbr>
              </Link>
            </div>
          )}

          {type === "my-profile" ? (
            <div className={`${styles.edit}`}>
              <abbr
                style={{
                  cursor: "pointer",
                  zIndex: 999,
                }}
                title={pinned ? "Unpin mineral" : "Pin mineral"}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handlePinToggle();
                }}
              >
                {pinned ? (
                  <SVG.Pin width="32px" fill={Colors.primary} />
                ) : (
                  <SVG.PinOutline width="32px" />
                )}
              </abbr>
            </div>
          ) : null}

          <div
            className={styles.cardClickableContent}
            style={{ paddingBottom: "12px" }}
          >
            <CustomImage
              src={image}
              alt={item?.specimentTitle || "Mineral Specimen"}
              className={styles.cardImage}
              width={300}
              height={300}
              quality={50}
              sizes="(max-width:768px) 50vw, 250px"
              style={{
                width: "100%",
                height: "auto",
                aspectRatio: 1,
                objectFit: "cover",
                ...customImageStyles,
              }}
            />
            <p className={`${styles.rattingData}`}>{item.specimentTitle}</p>
            <div>{renderStars(item?.rating)}</div>

            <div
              style={{
                display: " flex",
                margin: "10px 0px",
                color: "#5E5E5E",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              <div style={{ width: "10%" }}>
                <SVG.Location
                  style={{
                    width: "20px",
                  }}
                />
              </div>
              <div className={`${styles.countLocation}`}>
                {[
                  item.pocket,
                  item.minName,
                  item.miningdistrict,
                  item.city,
                  item.region,
                  item.state,
                  item.country,
                ].filter(Boolean).length === 0 ? (
                  <span>(Location not provided)</span>
                ) : (
                  [
                    item.pocket,
                    item.minName,
                    item.miningdistrict,
                    item.city,
                    item.region,
                    item.state,
                    item.country,
                  ]
                    .filter((el) => el)
                    .join(", ")
                )}
              </div>
            </div>

            <div
              style={{
                display: " flex",
                margin: "10px 0px",
                color: "#5E5E5E",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              <div style={{ width: "10%" }}>
                <SVG.Diamonds
                  style={{
                    width: "20px",
                  }}
                />
              </div>
              <div className={`${styles.countLocation}`}>
                <div>
                  <span> Mineral:</span> <span>{item.minerals.join(", ")}</span>
                </div>
              </div>
            </div>

            {item?.isDealerNamePublic && item?.dealerName ? (
              <div
                style={{
                  display: " flex",
                  margin: "10px 0px",
                  color: "#5E5E5E",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                <div style={{ width: "10%" }}>
                  <SVG.Diamonds
                    style={{
                      width: "20px",
                    }}
                  />
                </div>
                <div className={`${styles.countLocation}`}>
                  <div>
                    <span> Dealer:</span> <span>{item.dealerName}</span>
                  </div>
                </div>
              </div>
            ) : (
              <div
                style={{
                  display: " flex",
                  margin: "10px 0px",
                  color: "#5E5E5E",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                <div style={{ width: "10%" }}>
                  <SVG.Diamonds
                    style={{
                      width: "20px",
                    }}
                  />
                </div>
                <div className={`${styles.countLocation}`}>
                  <div>
                    <span> Dealer:</span> <span>{"N/A"}</span>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className={`${styles.countMsg}`}>
            <button className="heart" onClick={handleLikeClick}>
              <SVG.Heart fill={liked ? Colors.primary : "transparent"} />{" "}
              {likeCount || 0}
            </button>
            <button className="heart" onClick={handleCommentClick}>
              <SVG.Message />
              {item.comment?.length || 0}
            </button>
            <button className="heart" onClick={handleShareClick}>
              <SVG.Send />
              {item.share || 0}
            </button>
          </div>

          {mineralBadge ? (
            <div className={`${styles.ribbonwrapper}`}>
              <p className={`${styles.ribbon}`}>{mineralBadgeName}</p>
            </div>
          ) : featuredMinerals ? (
            <div className={`${styles.ribbonwrapper}`}>
              <p className={`${styles.ribbon}`}>Featured</p>
            </div>
          ) : null}
        </Card>
      </Link>

      <PopupModal
        className={`${styles.popup}`}
        visible={isUploadPopupVisible}
        onClose={handleUploadPopupClose}
        title=""
        content={
          <SocialShare
            customShareUrl={`https://collectmineralclub.com/minerals/${encodeURIComponent(
              item?.slug || mineralId
            )}`}
            handleShare={handleShare}
          />
        }
      />
    </Suspense>
  );
}

export default MineralCard;
